import { render } from "./EmptyListArea.vue?vue&type=template&id=07c83914&scoped=true&ts=true"
import script from "./EmptyListArea.vue?vue&type=script&lang=ts"
export * from "./EmptyListArea.vue?vue&type=script&lang=ts"

import "./EmptyListArea.vue?vue&type=style&index=0&id=07c83914&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c83914"]])

export default __exports__